import resolveDefaultProps from "utils/resolveDefaultProps";
import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const Td = React.forwardRef((props, ref) => {
  props = resolveDefaultProps(props, TdDefaults);

	const { children, className, asElement: Component, ...rest } = props

	const tdClass = classNames(
		Component !== 'td' && 'td',
		className
	)

	return (
		<Component className={tdClass} ref={ref} {...rest}>
			{children}
		</Component>
	)
})

Td.propTypes = {
	asElement: PropTypes.string
};

const TdDefaults = {
	asElement: 'td'
}


export default Td
